














import Vue from 'vue';
import api from '@/api';
import UserForm from '@/apps/FNM/components/UserForm.vue';
import { FNM_ROLES } from '@/constants';

export default Vue.extend({
  components: {
    UserForm
  },

  data() {
    return {
      active : false,
      loading: false,
      roles: FNM_ROLES,
      model: {
        firstname: '',
        lastname: '',
        email: '',
        role: '',
        phone: '',
      }
    }
  },

  computed: {
    userId(): string {
      return this.$route.params.userId;
    }
  },

  async mounted() {
    this.active = true
    try{
      const { data } = await api.get(`/users/${this.userId}`);
      this.model = {
        firstname: data.firstname,
        lastname: data.lastname,
        email: data.email,
        role: data.role,
        phone: data.phone,
      }
    }catch (error) {
      this.$notify.error('Erreur lors du chargement de l\'utilisateur');
    }
  },

  methods: {
    onEdit(this: any, user: any) {
      this.loading = true;
      api
        .put(`users/${this.userId}`, user)
        .then(() => {
          this.loading = false
          this.active = false
          this.$notify.success('Utilisateur modifié avec succès');
        })
        .catch((error: any) => {
          this.loading = false

          if(error.response && error.response.status === 400){
            this.$refs.form.setErrors(error.response.data.message);
          }
          this.$notify.error('La modification de l\'utilisateur a échouée');
        })
    }
  }
})
